module.exports = __webpack_public_path__ + "img/power-level-0.e6fd2385.png";